<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          @result="storeSerials"
        >
          <template v-slot:columns>
            <th style="width: 80%">{{ $t("Serial") }}</th>
            <th class="flex justify-center">
              <div class="flex items-center gap-2">
                <span>{{ $t("Select") }}</span>
                <vs-checkbox
                  @click="toggleSelectionOfAllSerials($event)"
                  :checked="isAllSelected"
                >
                </vs-checkbox>
              </div>
            </th>
          </template>
          <template slot-scope="{ row }">
            <td style="width: 80%">
              {{ row }}
            </td>
            <td class="flex justify-center">
              <vs-checkbox
                @click="toggleSerialSelection($event, row)"
                :checked="
                  selectedTransactionSerials
                    .map((item) => item.serial)
                    .includes(row)
                "
                :disabled="
                  !selectedTransactionSerials
                    .map((item) => item.serial)
                    .includes(row) &&
                  !selectedTransactionSerialsCountLessThanEnteredCount
                "
              >
              </vs-checkbox>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
  </div>
</template>
<style scoped></style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "warehouseManagement_TransferTransactions_Serials",
  components: {
    DataGrid,
  },
  props: {
    serialService: {
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      inventoryTransactions: "transferTransactions/inventoryTransactions",
      selectedTransactionSerials:
        "transferTransactions/selectedTransactionSerials",
      selectedTransactionSerialsCountLessThanEnteredCount:
        "transferTransactions/selectedTransactionSerialsCountLessThanEnteredCount",
      model: "transferTransactions/model",
      selectedTransactionCount: "transferTransactions/selectedTransactionCount",
    }),
    isAllSelected() {
      let isAllSelectedInThisPage = false;
      for (let serial of this.serials) {
        if (this.isThisSerialSelected(serial)) {
          isAllSelectedInThisPage = true;
        } else {
          isAllSelectedInThisPage = false;
        }
      }
      return (
        !this.selectedTransactionSerialsCountLessThanEnteredCount ||
        isAllSelectedInThisPage
      );
    },
    disableSelectAllCheckbox() {
      return !this.selectedTransactionSerialsCountLessThanEnteredCount;
    },
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: this.serialService,
      },
      gridSearchData: {
        keyword: "",
      },
      serials: [],
      chosenSerials: [],
    };
  },
  methods: {
    ...mapActions({
      addSerialToSelectedTransaction:
        "transferTransactions/addSerialToSelectedTransaction",
      removeSerialFromSelectedTransaction:
        "transferTransactions/removeSerialFromSelectedTransaction",
    }),
    storeSerials(serials) {
      this.serials = serials;
    },
    toggleSerialSelection(event, serial) {
      if (event.target.checked) {
        this.chosenSerials.push(serial);
        this.addSerialToSelectedTransaction(serial);
      } else {
        let serialIndex = this.selectedTransactionSerials
          .map((item) => item.serial)
          .indexOf(serial);

        this.removeSerialFromSelectedTransaction(serialIndex);
      }
    },
    isThisSerialSelected(serial) {
      return this.selectedTransactionSerials
        .map((item) => item.serial)
        .includes(serial);
    },
    nextAvailableSerialForSelectionIndex(index) {
      let currentIndex = index;
      while (this.isThisSerialSelected(this.serials[currentIndex])) {
        currentIndex++;
        // Loop back to the start if we reach the end of the array.
        if (currentIndex >= this.serials.length) currentIndex = 0;
        // Prevent infinite loop if all serials are chosen.
        if (currentIndex === index) return -1;
      }
      // currentIndex is now an unselected index.
      return currentIndex;
    },
    toggleSelectionOfAllSerials(event) {
      const maximumPotentialSelectableItems =
        this.selectedTransactionCount -
        this.selectedTransactionSerials.map((item) => item.serial).length;
      if (event.target.checked) {
        let lastIndexAdded = 0;
        for (let i = 0; i < maximumPotentialSelectableItems; i++) {
          let nextAvailableIndex =
            this.nextAvailableSerialForSelectionIndex(lastIndexAdded);
          if (nextAvailableIndex !== -1) {
            this.addSerialToSelectedTransaction(
              this.serials[nextAvailableIndex]
            );
            lastIndexAdded = nextAvailableIndex;
          } else {
            break;
          }
        }
      } else {
        for (let serial of this.serials) {
          if (this.isThisSerialSelected(serial)) {
            this.toggleSerialSelection({ target: { checked: false } }, serial);
          }
        }
      }
    },
  },
};
</script>
